












import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import { HsabExpenseResponse } from "@/shared/types";

@Component({})
export default class HsbExpenseCardRowPayee extends Vue {

  @Prop({ required: true })
  expense: HsabExpenseResponse;
}
